import { AbstractControl, ValidatorFn } from '@angular/forms';

export interface PasswordValidatorOpts {
  minLength?: number;
  maxLength?: number;
  requireUppercase?: boolean;
  requireLowercase?: boolean;
  requireNumber?: boolean;
  requireSymbol?: boolean;
}

export function passwordValidator(opts: PasswordValidatorOpts): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;
    if (!value || value === '') {
      return null;
    }

    // Validate min length
    if (opts?.minLength && value.length < opts.minLength) {
      return { passwordMinLength: true };
    }

    // Validate max length
    if (opts?.maxLength && value.length > opts.maxLength) {
      return { passwordMaxLength: true };
    }

    // Validate upper case
    if (opts?.requireUppercase) {
      const containsUppercaseRegexp = new RegExp('(?=.*[A-Z])');
      if (!containsUppercaseRegexp.test(value)) {
        return { passwordRequiresUppercase: true };
      }
    }

    // Validate lower case
    if (opts?.requireLowercase) {
      const containsLowercaseRegexp = new RegExp('(?=.*[a-z])');
      if (!containsLowercaseRegexp.test(value)) {
        return { passwordRequiresLowercase: true };
      }
    }

    // Validate number
    if (opts?.requireNumber) {
      const containsNumberRegexp = new RegExp('(?=.*\\d)');
      if (!containsNumberRegexp.test(value)) {
        return { passwordRequiresNumber: true };
      }
    }

    // Require at least one non-alphanumeric, non-whitespace character
    if (opts?.requireSymbol) {
      const containsSymbolRegexp = new RegExp('(?=.*[^\\w\\s])');
      if (!containsSymbolRegexp.test(value)) {
        return { passwordRequiresSymbol: true };
      }
    }

    return null;
  };
}
